var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.109,
    height: 32.844,
    viewBox: "0 0 45.109 32.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pasted-20240122-045034",
    transform: "translate(-14.191 -21.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15253",
    "data-name": "Group 15253",
    transform: "translate(15.177 22.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38107",
    "data-name": "Path 38107",
    d: "M57.151,72.921c.288-.444.7-.463.823-1.076a2.42,2.42,0,0,0-.364-2.121.333.333,0,0,1,.057-.479,1.534,1.534,0,0,0,.609-1.163c.123-1.559-.246-2.4-1.958-2.359q-1.338.035-2.664.026a2.319,2.319,0,0,0-1.251.406.315.315,0,0,1-.224.045,1.175,1.175,0,0,1-.975-.812A15.526,15.526,0,0,0,40.878,55.3a7.094,7.094,0,0,0-.731-.182,17.554,17.554,0,0,0-1.876-.361,21.373,21.373,0,0,0-3.876.012,13.031,13.031,0,0,0-2.147.443,15.362,15.362,0,0,0-10.595,10.06.756.756,0,0,1-.781.509q-1.673-.036-3.858-.043a1.64,1.64,0,0,0-1.822,1.569q-.03,4.063,0,8.01c.009,1.163.713,1.562,1.826,1.573,1.725.016,3.416-.024,5.2,0a.347.347,0,0,1,.328.208,14.469,14.469,0,0,0,2.984,4.049,15.2,15.2,0,0,0,8.651,4.214,15.641,15.641,0,0,0,9.7-1.741,15.456,15.456,0,0,0,6.153-6.132c.158-.276.352-.559.708-.576.8-.038,1.606-.069,2.411-.054q1.7.036,3.555.026c1.507-.009,1.687-1.116,1.553-2.357a1.511,1.511,0,0,0-1.008-1.279.227.227,0,0,1-.132-.14.223.223,0,0,1,.024-.19",
    transform: "translate(-15.177 -54.677)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38111",
    "data-name": "Path 38111",
    d: "M73.219,82.786q-.021-.024.024-.05a.122.122,0,0,0,.057-.061A12.227,12.227,0,0,1,84.119,75.5a12.359,12.359,0,0,1,9.93,4.652",
    transform: "translate(-63.139 -71.882)",
    fill: "none",
    stroke: "#9f8d4c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38112",
    "data-name": "Path 38112",
    d: "M191.813,102.31q.063.1-.005.161a1.064,1.064,0,0,0-.272,1.026",
    transform: "translate(-160.903 -94.042)",
    fill: "none",
    stroke: "#f27817",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38113",
    "data-name": "Path 38113",
    d: "M191.66,109.15l2.439,1.5a.33.33,0,0,0,.285.029.349.349,0,0,0,.208-.206A1.208,1.208,0,0,0,194.6,110",
    transform: "translate(-161.028 -99.695)",
    fill: "none",
    stroke: "#9f8d4c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38114",
    "data-name": "Path 38114",
    d: "M86.748,72.26q.019-.632.007-2.454a.544.544,0,0,0-.312-.559.179.179,0,0,0-.179.021.644.644,0,0,1-.4.141.214.214,0,0,1-.168-.087,13.9,13.9,0,0,0-21.8-1.067,14.361,14.361,0,0,0-2.682,4.693,1.106,1.106,0,0,0-.062.314q-.021.364.25.118a2.253,2.253,0,0,1,1.849-.517",
    transform: "translate(-53.172 -61.958)",
    fill: "none",
    stroke: "#f27817",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38115",
    "data-name": "Path 38115",
    d: "M194.573,108.64a.644.644,0,0,1-.849.043,16.972,16.972,0,0,0-1.942-1.147q-.134-.068-.151.028a.85.85,0,0,0,0,.229",
    transform: "translate(-160.997 -98.338)",
    fill: "none",
    stroke: "#95335a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38116",
    "data-name": "Path 38116",
    d: "M92.922,77.595q.078.028.094.016a.191.191,0,0,0,.031-.259,11.054,11.054,0,0,0-1.229-1.4,12.7,12.7,0,0,0-5.71-3.187A12.291,12.291,0,0,0,71.859,80.08q-.038.092.059.113l.174.038",
    transform: "translate(-62.012 -69.327)",
    fill: "none",
    stroke: "#95335a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38117",
    "data-name": "Path 38117",
    d: "M110.681,94.814a.083.083,0,0,1,.153-.045l.6.892a.154.154,0,0,0,.135.073h1.949a.192.192,0,0,0,.153-.071l.193-.226a.2.2,0,0,1,.161-.073l.932.012a.252.252,0,0,1,.175.071,1.155,1.155,0,0,0,1.015.318.168.168,0,0,0,.13-.236q-.712-1.567-1.465-3.057-.087-.17-.2-.347a.167.167,0,0,0-.293.019l-1.527,3.329a.191.191,0,0,1-.342.01,3.937,3.937,0,0,0-.63-.87.128.128,0,0,1,.024-.2,1.191,1.191,0,0,0,.606-1.456.967.967,0,0,0-.984-.765q-.811.014-1.619-.007a.1.1,0,0,0-.106.1l0,3.261a.164.164,0,0,0,.175.184l.512.026a.231.231,0,0,0,.241-.227l.01-.724",
    transform: "translate(-93.327 -85.56)",
    fill: "none",
    stroke: "#7f6b09",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38118",
    "data-name": "Path 38118",
    d: "M149.382,94.735a1.014,1.014,0,0,1-1.614-1.067,1.034,1.034,0,0,1,1.645-.528.416.416,0,0,0,.552-.057.859.859,0,0,0,.154-.194A.317.317,0,0,0,150,92.4c-1.319-.8-3.05-.3-3.192,1.35-.163,1.908,1.777,2.517,3.185,1.708a.31.31,0,0,0,.09-.543l-.106-.123a.388.388,0,0,0-.592-.061",
    transform: "translate(-123.95 -85.547)",
    fill: "none",
    stroke: "#7f6b09",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38119",
    "data-name": "Path 38119",
    d: "M82.3,164.059a.207.207,0,0,0,.207.253.234.234,0,0,1,.137.059.334.334,0,0,0,.163.083,2.935,2.935,0,0,0,2.5-.371,2.478,2.478,0,0,0,.79-1.257A.781.781,0,0,0,85.96,162",
    transform: "translate(-70.651 -143.372)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38120",
    "data-name": "Path 38120",
    d: "M88.851,157.613l.016-.531a.368.368,0,0,0-.328-.377,2.176,2.176,0,0,0-.778.052.367.367,0,0,0-.276.311,4.58,4.58,0,0,1-.167.786q-.361,1.166-1.519.583",
    transform: "translate(-73.542 -138.985)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38121",
    "data-name": "Path 38121",
    d: "M85.271,138.081q-.068-.759-.085-1.411-.045-1.744-.012-3.494.021-1.113,1.276-1.116",
    transform: "translate(-73.013 -118.629)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38122",
    "data-name": "Path 38122",
    d: "M92.59,132.06a.744.744,0,0,1,.276.349,4.523,4.523,0,0,0,.392,1.139",
    transform: "translate(-79.153 -118.629)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38123",
    "data-name": "Path 38123",
    d: "M96.44,136.407q1,.668,1.479-.312a.125.125,0,0,0-.019-.144.186.186,0,0,1-.04-.172.119.119,0,0,0-.064-.144l-.2-.115",
    transform: "translate(-82.335 -121.488)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38124",
    "data-name": "Path 38124",
    d: "M80.246,125.471a2.343,2.343,0,0,0-3.128-2.015c-1.284.318-1.649,1.444-1.661,2.638q-.014,1.68.012,3.338a2.9,2.9,0,0,0,1.173,2.694",
    transform: "translate(-64.99 -111.439)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38125",
    "data-name": "Path 38125",
    d: "M97.591,135.52l-.014.566a.346.346,0,0,1-.352.337l-.785-.016",
    transform: "translate(-82.335 -121.488)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38126",
    "data-name": "Path 38126",
    d: "M85.309,131.159q-.826-.446-1.239.16a1.945,1.945,0,0,0-.246,1.012q-.035.951-.043,3.07a3.671,3.671,0,0,0,.351,1.779",
    transform: "translate(-71.872 -117.728)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38127",
    "data-name": "Path 38127",
    d: "M85.967,162a5.258,5.258,0,0,1-.172.85,2.438,2.438,0,0,1-3.485,1.208",
    transform: "translate(-70.658 -143.372)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38128",
    "data-name": "Path 38128",
    d: "M197.764,127.685a14.511,14.511,0,0,1-.3-1.993.779.779,0,0,0-.3-.642",
    transform: "translate(-165.581 -112.835)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38129",
    "data-name": "Path 38129",
    d: "M173.625,124.1a.929.929,0,0,0-.89-.158.551.551,0,0,0-.476.542q-.035,2.072.012,4.188a.063.063,0,0,1-.024.052.067.067,0,0,1-.057.012.194.194,0,0,1-.061-.028.175.175,0,0,1-.064-.08q-.811-2.029-1.7-4.121c-.293-.686-.72-.644-1.369-.564a.346.346,0,0,0-.3.344l-.007,6.585",
    transform: "translate(-142.036 -111.887)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38130",
    "data-name": "Path 38130",
    d: "M159.193,132.071q-.443.094-.536-.706a7.581,7.581,0,0,0-.213-1.106q-.122-.448-.191-.842-.073-.427-.172-.847-.363-1.553-.587-2.8a1.091,1.091,0,0,0-.293-.415",
    transform: "translate(-132.549 -113.083)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38131",
    "data-name": "Path 38131",
    d: "M140.9,124.051a2.408,2.408,0,0,0-1.6-.246.448.448,0,0,0-.427.4q-.668,3.525-1.394,7.017",
    transform: "translate(-116.252 -111.784)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38132",
    "data-name": "Path 38132",
    d: "M134.786,133.208a2.446,2.446,0,0,1-.2-1.189c.056-.651-.1-1.255-.08-1.9q.049-1.6.01-3.324-.01-.517-.3-.62",
    transform: "translate(-113.558 -113.769)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38133",
    "data-name": "Path 38133",
    d: "M119.27,124.392a.629.629,0,0,0-.606-.375q-.785-.023-.781.712.005,1.177-.01,2.442c-.005.323-.2.443-.509.477a2.985,2.985,0,0,1-1.234-.082",
    transform: "translate(-98.608 -111.981)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38134",
    "data-name": "Path 38134",
    d: "M115.56,129.658a14.991,14.991,0,0,0,.043-2.881q-.024-.24-.163-.229",
    transform: "translate(-98.037 -114.073)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38135",
    "data-name": "Path 38135",
    d: "M108.6,124.362a.7.7,0,0,0-.325-.371c-.732-.278-1.109.127-1.107.85q.014,3.5-.005,7.193a.662.662,0,0,0,.529.7",
    transform: "translate(-91.194 -111.887)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38136",
    "data-name": "Path 38136",
    d: "M110.21,157.415a.448.448,0,0,0,.528.243q.687-.078.647-.687-.075-1.158-.073-2.348a1.577,1.577,0,0,1,.123-.627.208.208,0,0,1,.134-.121,1.58,1.58,0,0,1,.863-.08,2.728,2.728,0,0,0,.536.1",
    transform: "translate(-93.715 -136.566)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38137",
    "data-name": "Path 38137",
    d: "M126.1,154.49q.024,1.491.033,3a.5.5,0,0,0,.434.529",
    transform: "translate(-106.847 -137.165)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38138",
    "data-name": "Path 38138",
    d: "M128.79,173.866q.208.358.774.2a2.041,2.041,0,0,0,.632-.4",
    transform: "translate(-109.07 -153.016)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38139",
    "data-name": "Path 38139",
    d: "M136.89,173.67q.279.17.238.22",
    transform: "translate(-115.764 -153.016)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38140",
    "data-name": "Path 38140",
    d: "M138.26,166.851q.757.509,1.217-.1a1.226,1.226,0,0,0,.236-.58c.052-.371.108-.963.585-1.008a5.347,5.347,0,0,1,1.248.1",
    transform: "translate(-116.896 -145.977)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38141",
    "data-name": "Path 38141",
    d: "M157.19,165.77a2.215,2.215,0,0,0,.555,1.6",
    transform: "translate(-132.541 -146.487)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38142",
    "data-name": "Path 38142",
    d: "M160.39,173.952q.752.6,1.6-.212",
    transform: "translate(-135.185 -153.074)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38143",
    "data-name": "Path 38143",
    d: "M169.59,173.74l.154.132",
    transform: "translate(-142.788 -153.074)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38144",
    "data-name": "Path 38144",
    d: "M170.48,156.434a.572.572,0,0,0,.439.267c.68.125.986-.257.953-.9a23.7,23.7,0,0,1-.01-2.84.32.32,0,0,1,.274-.325",
    transform: "translate(-143.524 -135.636)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38145",
    "data-name": "Path 38145",
    d: "M180.02,152.64q.686,1.623,1.343,3.234a1.213,1.213,0,0,0,.483.606",
    transform: "translate(-151.408 -135.636)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38146",
    "data-name": "Path 38146",
    d: "M190.54,164.57a.761.761,0,0,0,.769.273.705.705,0,0,0,.609-.356,1.361,1.361,0,0,0,.054-.627,2.447,2.447,0,0,1,.314-1.43",
    transform: "translate(-160.102 -143.727)",
    fill: "none",
    stroke: "#fddc47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38147",
    "data-name": "Path 38147",
    d: "M200.6,162.43a4.017,4.017,0,0,0,.474,1.389,1.977,1.977,0,0,0,.97.772",
    transform: "translate(-168.416 -143.727)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38149",
    "data-name": "Path 38149",
    d: "M214.2,152.775l-.007-2.864a.587.587,0,0,0-.667-.661q-.708,0-1.474.019a.447.447,0,0,0-.427.495c.014.658.493.632.965.753a.217.217,0,0,1,.175.212c.069.936-.266,2.256-1.566,1.559",
    transform: "translate(-177.176 -132.835)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38150",
    "data-name": "Path 38150",
    d: "M210.073,138.089a25.237,25.237,0,0,1-.214-4.537,2.116,2.116,0,0,1,.255-1.106c.259-.352.686-.305,1.069-.377",
    transform: "translate(-176.049 -118.637)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M217.6,132.07a2.068,2.068,0,0,1,.477,1.359q.017.153.241.168",
    transform: "translate(-182.465 -118.637)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38152",
    "data-name": "Path 38152",
    d: "M221.74,137.3a1.06,1.06,0,0,0,1.1.181.32.32,0,0,0,.224-.281.879.879,0,0,0-.219-.649",
    transform: "translate(-185.887 -122.339)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38153",
    "data-name": "Path 38153",
    d: "M205.36,125.608a2.178,2.178,0,0,0-1.744-2.225,2.5,2.5,0,0,0-2.593.854,3.45,3.45,0,0,0-.434,2.01",
    transform: "translate(-168.407 -111.398)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38154",
    "data-name": "Path 38154",
    d: "M222.84,136.55a.862.862,0,0,1-.031.548.193.193,0,0,1-.118.111,2.459,2.459,0,0,1-.951.09",
    transform: "translate(-185.887 -122.339)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38155",
    "data-name": "Path 38155",
    d: "M210.358,131.129q-.814-.45-1.238.123a1.8,1.8,0,0,0-.255,1q-.054,1.508-.005,3.595a2.244,2.244,0,0,0,.387,1.3",
    transform: "translate(-175.223 -117.696)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38157",
    "data-name": "Path 38157",
    d: "M200.592,144.083l0-3.853",
    transform: "translate(-168.408 -125.38)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38158",
    "data-name": "Path 38158",
    d: "M191.691,125.05q.014,3.931.019,7.759a1.333,1.333,0,0,1-.177.7.216.216,0,0,1-.128.1,2.178,2.178,0,0,1-.864.066",
    transform: "translate(-160.102 -112.835)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38159",
    "data-name": "Path 38159",
    d: "M172.136,147.836l-.344-.774q-.219-.491-.212.045.019,1.79.005,3.959c-.005.606-.552.71-1.106.564",
    transform: "translate(-143.524 -130.833)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38160",
    "data-name": "Path 38160",
    d: "M168.838,165.748a.623.623,0,0,1-.132-.432q-.019-.647-.026-1.246",
    transform: "translate(-142.036 -145.083)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38161",
    "data-name": "Path 38161",
    d: "M157.2,125.35q.842,4.1,1.611,8.009a.5.5,0,0,1-.085.444.51.51,0,0,1-.371.12q-.252.007-.6.038",
    transform: "translate(-132.549 -113.083)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38162",
    "data-name": "Path 38162",
    d: "M141.546,163.887a1.287,1.287,0,0,0-1.241-.382c-1.243.122-.474,1.5-1.333,1.869a1.617,1.617,0,0,1-.712.1",
    transform: "translate(-116.896 -144.605)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38163",
    "data-name": "Path 38163",
    d: "M136.89,167.885l.1-1.215",
    transform: "translate(-115.764 -147.231)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38164",
    "data-name": "Path 38164",
    d: "M115.121,126.55a10.1,10.1,0,0,0,.12,3.11",
    transform: "translate(-97.719 -114.075)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38165",
    "data-name": "Path 38165",
    d: "M129.732,126.18q.026,3.94,0,7.866a.511.511,0,0,1-.25.495,1.416,1.416,0,0,1-.693.078",
    transform: "translate(-109.07 -113.769)",
    fill: "none",
    stroke: "#89978c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38166",
    "data-name": "Path 38166",
    d: "M112.968,152.784a.627.627,0,0,0-.54-.342c-.467-.023-1.3-.116-1.333.606q-.047,1.246-.033,2.65.007.7-.852.611",
    transform: "translate(-93.715 -135.459)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38167",
    "data-name": "Path 38167",
    d: "M22.68,174.209a16.642,16.642,0,0,0,3.333.153,1.854,1.854,0,0,0,.746-.382",
    transform: "translate(-21.378 -153.272)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38168",
    "data-name": "Path 38168",
    d: "M46.18,173.98a.592.592,0,0,0,.2.151",
    transform: "translate(-40.799 -153.272)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38169",
    "data-name": "Path 38169",
    d: "M47.34,162.511a1.022,1.022,0,0,0,1.675-.581,10.2,10.2,0,0,1,.866-2.01",
    transform: "translate(-41.758 -141.653)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38170",
    "data-name": "Path 38170",
    d: "M61.98,159.92q.488,1.147.944,2.151a.688.688,0,0,0,.451.425",
    transform: "translate(-53.856 -141.653)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38171",
    "data-name": "Path 38171",
    d: "M70.02,172.76a.826.826,0,0,0,.908.269q.883-.238.222-.689",
    transform: "translate(-60.501 -151.917)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38172",
    "data-name": "Path 38172",
    d: "M71,160.068,69.84,157.49",
    transform: "translate(-60.352 -139.645)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38173",
    "data-name": "Path 38173",
    d: "M67.853,131.606a.793.793,0,0,0-.035-.476,4.842,4.842,0,0,1-.338-.729.829.829,0,0,1,.04-.628q.689-1.47,1.35-3.126a.422.422,0,0,0,.021-.245.352.352,0,0,0-.139-.233",
    transform: "translate(-58.365 -113.761)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38174",
    "data-name": "Path 38174",
    d: "M51.3,124.318q-.089-.34-.351-.365c-.417-.038-.982-.094-1.173.375q-.432,1.057-.79,2.119a.092.092,0,0,1-.153.036,1.037,1.037,0,0,1-.262-.411q-.26-.772-.62-1.569a.852.852,0,0,0-.847-.538l-.319,0q-.66.009-.389.609l1.5,3.339a.658.658,0,0,1,.007.529l-1.581,3.74",
    transform: "translate(-40.911 -111.909)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38175",
    "data-name": "Path 38175",
    d: "M44.426,171.037a.84.84,0,0,1-.406-.1",
    transform: "translate(-39.014 -150.76)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38176",
    "data-name": "Path 38176",
    d: "M32.029,167.436a.777.777,0,0,0-.279-.625.26.26,0,0,0-.158-.061l-2.081-.05",
    transform: "translate(-27.022 -147.256)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38177",
    "data-name": "Path 38177",
    d: "M29.5,149.833a.1.1,0,0,1,.042-.094.22.22,0,0,0,.069-.163l.009-1.52a.483.483,0,0,1,.555-.543q.554.007,1.121,0a.687.687,0,0,0,.536-.259q.325-.378-.073-.965",
    transform: "translate(-27.014 -130.389)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38178",
    "data-name": "Path 38178",
    d: "M32.919,144.5q-.007-.326-.439-.323-.8.007-1.579-.052",
    transform: "translate(-28.171 -128.604)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38180",
    "data-name": "Path 38180",
    d: "M24.852,124.731q.108-.642-.279-.646-1.531-.01-3.166,0a.461.461,0,0,0-.517.519q-.024,4,.007,7.707a1.044,1.044,0,0,0,.3.66",
    transform: "translate(-19.889 -112.034)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38182",
    "data-name": "Path 38182",
    d: "M31.319,146.29q.092,1.055-.644,1a9.62,9.62,0,0,0-1.293,0,.4.4,0,0,0-.37.361,15.6,15.6,0,0,0-.024,2.085q.005.1.071.1",
    transform: "translate(-26.571 -130.389)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38183",
    "data-name": "Path 38183",
    d: "M26.384,170.94q-.078.71-.741.675a18.581,18.581,0,0,0-2.963.082",
    transform: "translate(-21.378 -150.76)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38184",
    "data-name": "Path 38184",
    d: "M67.684,126.17q-.649,1.685-1.4,3.355a1.141,1.141,0,0,0-.109.738q.106.3.614,1.343",
    transform: "translate(-57.297 -113.761)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38185",
    "data-name": "Path 38185",
    d: "M71.15,172.34q.08.373-.309.4-.368.024-.821.021",
    transform: "translate(-60.501 -151.917)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38186",
    "data-name": "Path 38186",
    d: "M49.881,158.353a.436.436,0,0,0-.087-.272.115.115,0,0,0-.207.019q-.245.668-.512,1.324a8.04,8.04,0,0,1-.489,1.083,1.3,1.3,0,0,1-1.246.437",
    transform: "translate(-41.758 -140.086)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38187",
    "data-name": "Path 38187",
    d: "M46.18,171.93l.031-.43",
    transform: "translate(-40.799 -151.223)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38189",
    "data-name": "Path 38189",
    d: "M243.853,167.133a.593.593,0,0,0-.533-.4q-.915.012-1.824-.009a.2.2,0,0,1-.106-.042",
    transform: "translate(-202.126 -147.24)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38191",
    "data-name": "Path 38191",
    d: "M243.557,143.9q-.094-.247-.264-.252-.826-.028-1.654-.035a.359.359,0,0,1-.279-.137",
    transform: "translate(-202.101 -128.066)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38192",
    "data-name": "Path 38192",
    d: "M241.36,128.927l.047-.057a.206.206,0,0,0,.047-.135l-.014-1.323a.272.272,0,0,1,.078-.194.268.268,0,0,1,.191-.081q.894,0,1.781-.017a.8.8,0,0,0,.4-.116.223.223,0,0,0,.1-.128,1.053,1.053,0,0,0-.153-1",
    transform: "translate(-202.101 -113.513)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38193",
    "data-name": "Path 38193",
    d: "M236.368,124.326a.383.383,0,0,0-.415-.314q-1.472-.014-3.031-.009a.513.513,0,0,0-.576.576q-.016,3.735-.026,7.582a.881.881,0,0,0,.422.738",
    transform: "translate(-194.63 -111.969)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38194",
    "data-name": "Path 38194",
    d: "M243.179,125.87l-.031.66a.4.4,0,0,1-.4.378l-1.805-.016a.365.365,0,0,0-.368.351q-.028.708,0,1.3a.584.584,0,0,0,.123.387",
    transform: "translate(-201.442 -113.513)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38196",
    "data-name": "Path 38196",
    d: "M238.365,169.29q.087,1.01-.752.965a17.8,17.8,0,0,0-2.864.071",
    transform: "translate(-196.639 -149.396)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38197",
    "data-name": "Path 38197",
    d: "M77.36,186.565q.2.231.323.194a.894.894,0,0,0,.529-.4.086.086,0,0,1,.109-.031,1.149,1.149,0,0,1,.38.3,2.193,2.193,0,0,0,.326.312,14.135,14.135,0,0,0,7.51,3.015,13.939,13.939,0,0,0,13.269-6.729.235.235,0,0,0-.031-.316",
    transform: "translate(-66.567 -160.652)",
    fill: "none",
    stroke: "#9f8d4c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38198",
    "data-name": "Path 38198",
    d: "M97.174,182.2a.858.858,0,0,0-.732-.108,2.671,2.671,0,0,1-1.3.255c-.224-.04-.33.083-.455.236A12.245,12.245,0,0,1,77.439,184.6a.17.17,0,0,1-.068-.125.148.148,0,0,1,.021-.094.775.775,0,0,0-.122-.811,1.038,1.038,0,0,0-.488-.316q-.97-.352-2.067-.8a.64.64,0,0,0-.3-.071.215.215,0,0,0-.2.259,17.136,17.136,0,0,0,.545,3.211",
    transform: "translate(-63.965 -159.94)",
    fill: "none",
    stroke: "#f27817",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38199",
    "data-name": "Path 38199",
    d: "M99.777,182.858a.31.31,0,0,0-.351.109,13.678,13.678,0,0,1-2.046,2.609,13.854,13.854,0,0,1-10.117,3.912,13.183,13.183,0,0,1-3.414-.509,13.776,13.776,0,0,1-4.462-2.192,7.61,7.61,0,0,1-.8-.679.521.521,0,0,0-.6-.142.854.854,0,0,0-.325.26,1.775,1.775,0,0,1-.305.286",
    transform: "translate(-66.567 -160.601)",
    fill: "none",
    stroke: "#95335a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38200",
    "data-name": "Path 38200",
    d: "M115.684,97.477a.427.427,0,1,0-.427.427.427.427,0,0,0,.427-.427",
    transform: "translate(-97.533 -89.695)",
    fill: "none",
    stroke: "#7f6b09",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38201",
    "data-name": "Path 38201",
    d: "M135.95,104.393l-.236-.467a.04.04,0,0,0-.054-.017l-.03.014a.628.628,0,0,0-.256.228.259.259,0,0,0-.026.251l0,.005c.074.147.321.172.552.056l.029-.016a.04.04,0,0,0,.017-.054",
    transform: "translate(-114.471 -95.36)",
    fill: "none",
    stroke: "#7f6b09",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38202",
    "data-name": "Path 38202",
    d: "M148.42,144.693q.042.1.087.109a2.635,2.635,0,0,0,.941.047.141.141,0,0,0,.1-.057.138.138,0,0,0,.024-.108l-.43-2.2",
    transform: "translate(-125.293 -127.24)",
    fill: "none",
    stroke: "#888e4f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38203",
    "data-name": "Path 38203",
    d: "M148.744,138.141a3.33,3.33,0,0,0-.12-.736q-.111-.356-.181.01-.243,1.291-.5,2.68a.394.394,0,0,0,.08.259",
    transform: "translate(-124.9 -122.901)",
    fill: "none",
    stroke: "#8aa4ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38204",
    "data-name": "Path 38204",
    d: "M149.137,142.48a5.151,5.151,0,0,0-.55,2.065q-.007.113-.167.148",
    transform: "translate(-125.293 -127.24)",
    fill: "none",
    stroke: "#fee984",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38217",
    "data-name": "Path 38217",
    d: "M57.151,72.921a.223.223,0,0,0-.024.19.227.227,0,0,0,.132.14,1.511,1.511,0,0,1,1.008,1.279c.134,1.241-.047,2.348-1.553,2.357q-1.855.01-3.555-.026c-.805-.016-1.612.016-2.411.054-.356.017-.55.3-.708.576a15.456,15.456,0,0,1-6.153,6.132,15.641,15.641,0,0,1-9.7,1.741,15.2,15.2,0,0,1-8.651-4.214A14.469,14.469,0,0,1,22.551,77.1a.347.347,0,0,0-.328-.208c-1.788-.026-3.478.014-5.2,0-1.113-.01-1.817-.41-1.826-1.573q-.031-3.947,0-8.01a1.64,1.64,0,0,1,1.822-1.569q2.185.007,3.858.043a.756.756,0,0,0,.781-.509,15.362,15.362,0,0,1,10.595-10.06,13.031,13.031,0,0,1,2.147-.443,21.373,21.373,0,0,1,3.876-.012,17.554,17.554,0,0,1,1.876.361,7.094,7.094,0,0,1,.731.182A15.526,15.526,0,0,1,51.2,65.388a1.175,1.175,0,0,0,.975.812.315.315,0,0,0,.224-.045,2.319,2.319,0,0,1,1.251-.406q1.326.009,2.664-.026c1.711-.045,2.081.8,1.958,2.359a1.534,1.534,0,0,1-.609,1.163.333.333,0,0,0-.057.479,2.42,2.42,0,0,1,.364,2.121C57.849,72.458,57.439,72.477,57.151,72.921Zm-31.894-7.34q-.021-.024.024-.05a.122.122,0,0,0,.057-.061,12.227,12.227,0,0,1,10.819-7.177,12.359,12.359,0,0,1,9.93,4.652q.062.1-.005.161a1.064,1.064,0,0,0-.273,1.026l2.439,1.5a.33.33,0,0,0,.285.029.349.349,0,0,0,.208-.206,1.208,1.208,0,0,0,.012-.477q.019-.632.007-2.454a.544.544,0,0,0-.312-.559.179.179,0,0,0-.179.021.644.644,0,0,1-.4.141.214.214,0,0,1-.168-.087,13.9,13.9,0,0,0-21.8-1.067,14.361,14.361,0,0,0-2.682,4.693,1.106,1.106,0,0,0-.062.314q-.021.364.25.118A2.253,2.253,0,0,1,25.257,65.581Zm7.274-1.651a.083.083,0,0,1,.153-.045l.6.892a.154.154,0,0,0,.135.073h1.949a.192.192,0,0,0,.153-.071l.193-.226a.2.2,0,0,1,.161-.073l.932.012a.252.252,0,0,1,.175.071A1.155,1.155,0,0,0,38,64.882a.168.168,0,0,0,.13-.236q-.712-1.567-1.465-3.057-.087-.17-.2-.347a.167.167,0,0,0-.293.019L34.642,64.59a.191.191,0,0,1-.342.01,3.936,3.936,0,0,0-.63-.87.128.128,0,0,1,.024-.2,1.191,1.191,0,0,0,.606-1.456.967.967,0,0,0-.984-.765q-.811.014-1.619-.007a.1.1,0,0,0-.106.1l0,3.261a.164.164,0,0,0,.175.184l.512.026a.231.231,0,0,0,.241-.227Zm8.078-.066A1.014,1.014,0,0,1,39,62.8a1.034,1.034,0,0,1,1.645-.528.416.416,0,0,0,.552-.057.859.859,0,0,0,.154-.194.317.317,0,0,0-.123-.484c-1.319-.8-3.05-.3-3.192,1.35-.163,1.908,1.777,2.517,3.185,1.708a.31.31,0,0,0,.09-.543l-.106-.123A.388.388,0,0,0,40.609,63.865Zm-13.78,11.5a.207.207,0,0,0,.207.253.233.233,0,0,1,.137.059.334.334,0,0,0,.163.083,2.935,2.935,0,0,0,2.5-.371,2.478,2.478,0,0,0,.79-1.257.781.781,0,0,0-.141-.826l.016-.531a.368.368,0,0,0-.328-.377,2.177,2.177,0,0,0-.778.052.367.367,0,0,0-.276.311,4.581,4.581,0,0,1-.167.786q-.361,1.166-1.519.583-.068-.758-.085-1.411-.045-1.744-.012-3.494.021-1.113,1.276-1.116a.744.744,0,0,1,.276.349,4.523,4.523,0,0,0,.392,1.139q1,.668,1.479-.312a.125.125,0,0,0-.019-.144.186.186,0,0,1-.04-.172.119.119,0,0,0-.064-.144l-.2-.115a2.343,2.343,0,0,0-3.128-2.015c-1.284.318-1.649,1.444-1.661,2.638q-.014,1.68.012,3.338A2.9,2.9,0,0,0,26.83,75.364Zm20.53-5.837a14.507,14.507,0,0,1-.3-1.993.779.779,0,0,0-.3-.642.929.929,0,0,0-.89-.158.551.551,0,0,0-.476.542q-.035,2.072.012,4.188a.063.063,0,0,1-.024.052.067.067,0,0,1-.057.012.193.193,0,0,1-.061-.028.175.175,0,0,1-.064-.08Q44.4,69.391,43.5,67.3c-.293-.686-.72-.644-1.369-.564a.346.346,0,0,0-.3.344l-.007,6.585q-.443.094-.536-.706a7.583,7.583,0,0,0-.213-1.106q-.122-.448-.191-.842-.073-.427-.172-.847-.363-1.553-.587-2.8a1.091,1.091,0,0,0-.293-.415,2.408,2.408,0,0,0-1.6-.246.448.448,0,0,0-.427.4q-.668,3.525-1.394,7.017a2.446,2.446,0,0,1-.2-1.189c.056-.651-.1-1.255-.08-1.9q.049-1.6.01-3.324-.01-.517-.3-.62a.629.629,0,0,0-.606-.375q-.785-.023-.781.712.005,1.177-.01,2.442c-.005.323-.2.443-.509.477a2.985,2.985,0,0,1-1.234-.082,14.99,14.99,0,0,0,.043-2.881q-.024-.24-.163-.229a.7.7,0,0,0-.325-.371c-.732-.278-1.109.127-1.107.85q.014,3.5-.005,7.193a.662.662,0,0,0,.529.7.448.448,0,0,0,.528.243q.687-.078.647-.687-.075-1.158-.073-2.348a1.577,1.577,0,0,1,.123-.627.208.208,0,0,1,.134-.121,1.58,1.58,0,0,1,.863-.08,2.726,2.726,0,0,0,.536.1q.024,1.491.033,3a.5.5,0,0,0,.434.529q.208.358.774.2a2.041,2.041,0,0,0,.632-.4q.279.17.238.22.757.509,1.217-.1a1.226,1.226,0,0,0,.236-.58c.052-.371.108-.963.585-1.008a5.348,5.348,0,0,1,1.248.1,2.215,2.215,0,0,0,.555,1.6q.752.6,1.6-.212l.154.132a.572.572,0,0,0,.439.267c.68.125.986-.257.953-.9a23.694,23.694,0,0,1-.01-2.84.32.32,0,0,1,.274-.325q.686,1.623,1.343,3.234a1.213,1.213,0,0,0,.483.606.761.761,0,0,0,.769.273.705.705,0,0,0,.609-.356,1.361,1.361,0,0,0,.054-.627,2.447,2.447,0,0,1,.314-1.43,4.018,4.018,0,0,0,.474,1.389,1.977,1.977,0,0,0,.97.772,1.436,1.436,0,0,0,1.331.283,2.231,2.231,0,0,1,1.277-.09c.781.233,1.312-.415.786-1.116l-.007-2.864a.587.587,0,0,0-.667-.661q-.708,0-1.474.019a.447.447,0,0,0-.427.495c.014.658.493.632.965.753a.217.217,0,0,1,.175.212c.069.936-.266,2.256-1.566,1.559a25.238,25.238,0,0,1-.213-4.537,2.116,2.116,0,0,1,.255-1.106c.259-.352.686-.305,1.069-.377a2.067,2.067,0,0,1,.477,1.359q.017.153.241.168a1.06,1.06,0,0,0,1.1.181.32.32,0,0,0,.224-.281.879.879,0,0,0-.219-.649,2.178,2.178,0,0,0-1.744-2.225,2.5,2.5,0,0,0-2.593.854A3.449,3.449,0,0,0,47.36,69.526ZM16.48,75.614a16.645,16.645,0,0,0,3.333.153,1.855,1.855,0,0,0,.746-.382.591.591,0,0,0,.2.151,1.022,1.022,0,0,0,1.675-.581,10.2,10.2,0,0,1,.866-2.01q.488,1.147.944,2.151a.688.688,0,0,0,.451.425.826.826,0,0,0,.908.269q.883-.238.222-.689l-1.161-2.578a.793.793,0,0,0-.035-.476,4.844,4.844,0,0,1-.338-.729.829.829,0,0,1,.04-.628q.689-1.47,1.35-3.126a.422.422,0,0,0,.021-.245.352.352,0,0,0-.139-.233q-.089-.34-.351-.365c-.417-.038-.982-.094-1.173.375q-.432,1.057-.79,2.119a.092.092,0,0,1-.153.036,1.037,1.037,0,0,1-.262-.411q-.26-.772-.62-1.569a.852.852,0,0,0-.847-.538l-.319,0q-.66.009-.389.609l1.5,3.339a.658.658,0,0,1,.007.529l-1.581,3.74a.84.84,0,0,1-.406-.1.777.777,0,0,0-.279-.625.26.26,0,0,0-.158-.061l-2.081-.05a.1.1,0,0,1,.042-.094.22.22,0,0,0,.069-.163l.009-1.52a.483.483,0,0,1,.555-.543q.554.007,1.121,0A.687.687,0,0,0,20,71.543q.325-.378-.073-.965-.007-.326-.439-.323-.8.007-1.579-.052l-.127-1.552q-.03-.352.326-.352.845,0,1.647.005a.754.754,0,0,0,.481-.161q.354-.279-.094-.769.108-.642-.279-.646-1.531-.01-3.166,0a.461.461,0,0,0-.517.519q-.024,4,.007,7.707A1.044,1.044,0,0,0,16.48,75.614Zm36.809-.007a13.076,13.076,0,0,0,2.722.175,2.015,2.015,0,0,0,.828-.163q.609-.321.066-1.048a.593.593,0,0,0-.533-.4q-.915.012-1.824-.009a.2.2,0,0,1-.106-.042.211.211,0,0,0,.062-.241.264.264,0,0,1-.021-.111l.036-1.557a.444.444,0,0,1,.455-.434q.491.012,1,.009,1.269-.007.658-1.269-.094-.247-.264-.252-.826-.028-1.654-.035a.359.359,0,0,1-.279-.137l.047-.057a.206.206,0,0,0,.047-.135l-.014-1.323a.272.272,0,0,1,.078-.194.268.268,0,0,1,.191-.081q.894,0,1.781-.017a.8.8,0,0,0,.4-.116.223.223,0,0,0,.1-.128,1.053,1.053,0,0,0-.153-1,.384.384,0,0,0-.415-.314q-1.472-.014-3.031-.009a.513.513,0,0,0-.576.576q-.016,3.735-.026,7.582A.881.881,0,0,0,53.289,75.607ZM25.971,80.59q.2.231.323.194a.9.9,0,0,0,.529-.4.086.086,0,0,1,.109-.031,1.15,1.15,0,0,1,.38.3,2.192,2.192,0,0,0,.326.312,14.135,14.135,0,0,0,7.51,3.015A13.939,13.939,0,0,0,48.418,77.25a.235.235,0,0,0-.031-.316.858.858,0,0,0-.732-.108,2.671,2.671,0,0,1-1.3.255c-.224-.04-.33.083-.455.236a12.245,12.245,0,0,1-17.249,2.019.17.17,0,0,1-.068-.125.148.148,0,0,1,.021-.094.775.775,0,0,0-.121-.811A1.038,1.038,0,0,0,28,77.991q-.97-.352-2.067-.8a.64.64,0,0,0-.3-.071.215.215,0,0,0-.2.259A17.134,17.134,0,0,0,25.971,80.59Z",
    transform: "translate(0 -31.926)",
    fill: "#fcd209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38218",
    "data-name": "Path 38218",
    d: "M86.748,72.26a.644.644,0,0,1-.849.043,16.977,16.977,0,0,0-1.942-1.147q-.134-.068-.151.028a.85.85,0,0,0,0,.229,1.064,1.064,0,0,1,.272-1.026q.068-.063.005-.161.078.028.094.016a.191.191,0,0,0,.031-.259,11.053,11.053,0,0,0-1.229-1.4,12.7,12.7,0,0,0-5.71-3.187,12.291,12.291,0,0,0-14.248,7.313q-.038.092.059.113l.174.038a2.253,2.253,0,0,0-1.849.517q-.271.246-.25-.118a1.106,1.106,0,0,1,.062-.314A14.361,14.361,0,0,1,63.9,68.254a13.9,13.9,0,0,1,21.8,1.067.214.214,0,0,0,.168.087.644.644,0,0,0,.4-.141.179.179,0,0,1,.179-.021.544.544,0,0,1,.312.559Q86.767,71.628,86.748,72.26Z",
    transform: "translate(-37.994 -39.207)",
    fill: "#e71d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38219",
    "data-name": "Path 38219",
    d: "M92.922,77.595a12.359,12.359,0,0,0-9.93-4.652A12.227,12.227,0,0,0,72.173,80.12a.122.122,0,0,1-.057.061q-.045.026-.024.05l-.174-.038q-.1-.021-.059-.113a12.291,12.291,0,0,1,14.248-7.313,12.7,12.7,0,0,1,5.71,3.187,11.055,11.055,0,0,1,1.229,1.4.191.191,0,0,1-.031.259Q93,77.622,92.922,77.595Z",
    transform: "translate(-46.834 -46.576)",
    fill: "#42488e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38220",
    "data-name": "Path 38220",
    d: "M110.681,94.814l-.01.724a.231.231,0,0,1-.241.227l-.512-.026a.164.164,0,0,1-.175-.184l0-3.261a.1.1,0,0,1,.106-.1q.809.021,1.619.007a.967.967,0,0,1,.984.765,1.191,1.191,0,0,1-.606,1.456.128.128,0,0,0-.024.2,3.936,3.936,0,0,1,.63.87.191.191,0,0,0,.342-.01l1.527-3.329a.167.167,0,0,1,.293-.019q.111.177.2.347.753,1.489,1.465,3.057a.168.168,0,0,1-.13.236,1.155,1.155,0,0,1-1.015-.318.252.252,0,0,0-.175-.071l-.932-.012a.2.2,0,0,0-.161.073l-.193.226a.192.192,0,0,1-.153.071h-1.949a.154.154,0,0,1-.135-.073l-.6-.892a.083.083,0,0,0-.153.045Zm.8-1.472a.427.427,0,1,0-.427.427.427.427,0,0,0,.427-.427Zm3.327,1.251-.236-.467a.04.04,0,0,0-.054-.017l-.03.014a.628.628,0,0,0-.256.228.259.259,0,0,0-.026.251l0,.005c.074.147.321.172.552.056l.029-.016a.04.04,0,0,0,.017-.054Z",
    transform: "translate(-78.149 -62.809)",
    fill: "#020408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38221",
    "data-name": "Path 38221",
    d: "M147.767,93.668a1.014,1.014,0,0,0,1.614,1.067.388.388,0,0,1,.592.061l.106.123a.31.31,0,0,1-.09.543c-1.408.809-3.348.2-3.185-1.708.142-1.654,1.873-2.147,3.192-1.35a.317.317,0,0,1,.123.484.859.859,0,0,1-.154.194.416.416,0,0,1-.552.057A1.034,1.034,0,0,0,147.767,93.668Z",
    transform: "translate(-108.772 -62.797)",
    fill: "#020408"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2766",
    "data-name": "Ellipse 2766",
    cx: 0.427,
    cy: 0.427,
    r: 0.427,
    transform: "translate(32.474 30.106)",
    fill: "#fcd209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38222",
    "data-name": "Path 38222",
    d: "M135.95,104.393a.04.04,0,0,1-.017.054l-.029.016c-.231.117-.478.092-.552-.056l0-.005a.259.259,0,0,1,.026-.251.628.628,0,0,1,.256-.228l.03-.014a.04.04,0,0,1,.054.017Z",
    transform: "translate(-99.294 -72.609)",
    fill: "#fcd209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38223",
    "data-name": "Path 38223",
    d: "M194.573,108.64a1.208,1.208,0,0,1-.012.477.349.349,0,0,1-.208.206.33.33,0,0,1-.285-.029l-2.439-1.5a.85.85,0,0,1,0-.229q.017-.1.151-.028a16.972,16.972,0,0,1,1.942,1.147A.644.644,0,0,0,194.573,108.64Z",
    transform: "translate(-145.819 -75.587)",
    fill: "#42488e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38224",
    "data-name": "Path 38224",
    d: "M80.246,125.471l-.014.566a.346.346,0,0,1-.352.337l-.785-.016a4.524,4.524,0,0,1-.392-1.139.744.744,0,0,0-.276-.349q-.826-.446-1.239.16a1.944,1.944,0,0,0-.246,1.012q-.035.951-.043,3.07a3.67,3.67,0,0,0,.351,1.779q1.158.583,1.519-.583a4.582,4.582,0,0,0,.167-.786.367.367,0,0,1,.276-.311,2.176,2.176,0,0,1,.778-.052.368.368,0,0,1,.328.377l-.016.531a5.26,5.26,0,0,1-.172.851,2.438,2.438,0,0,1-3.485,1.208,2.9,2.9,0,0,1-1.173-2.694q-.026-1.658-.012-3.338c.012-1.194.377-2.321,1.661-2.638A2.343,2.343,0,0,1,80.246,125.471Z",
    transform: "translate(-49.813 -88.688)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38225",
    "data-name": "Path 38225",
    d: "M205.36,125.608a.862.862,0,0,1-.031.548.193.193,0,0,1-.118.111,2.459,2.459,0,0,1-.951.09q-.224-.016-.241-.168a2.067,2.067,0,0,0-.477-1.359q-.814-.45-1.238.123a1.8,1.8,0,0,0-.255,1q-.054,1.508-.005,3.595a2.244,2.244,0,0,0,.387,1.3c1.3.7,1.635-.623,1.566-1.559a.217.217,0,0,0-.175-.212c-.472-.122-.951-.1-.965-.753a.447.447,0,0,1,.427-.495q.765-.016,1.474-.019a.587.587,0,0,1,.667.661l.007,2.864c-.056.38.071.83-.481.882a2.327,2.327,0,0,1-.927-.1.27.27,0,0,0-.187.007,2.889,2.889,0,0,1-1.8.134,1.977,1.977,0,0,1-.97-.772,4.017,4.017,0,0,1-.474-1.389l0-3.853a3.45,3.45,0,0,1,.434-2.01,2.5,2.5,0,0,1,2.593-.854A2.178,2.178,0,0,1,205.36,125.608Z",
    transform: "translate(-153.229 -88.647)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38226",
    "data-name": "Path 38226",
    d: "M24.852,124.731q.128.732-.453.708-.892-.038-1.8-.016a.268.268,0,0,0-.293.283,13.677,13.677,0,0,0,0,1.571q.014.207.311.283.778.059,1.579.052.432,0,.439.323.092,1.055-.644,1a9.625,9.625,0,0,0-1.293,0,.4.4,0,0,0-.37.361,15.6,15.6,0,0,0-.024,2.085q.005.1.071.1l2.081.05a.26.26,0,0,1,.158.061.777.777,0,0,1,.279.625q-.078.71-.741.675a18.574,18.574,0,0,0-2.963.082,1.044,1.044,0,0,1-.3-.66q-.031-3.706-.007-7.707a.461.461,0,0,1,.517-.519q1.635-.01,3.166,0Q24.96,124.089,24.852,124.731Z",
    transform: "translate(-4.712 -89.283)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38227",
    "data-name": "Path 38227",
    d: "M51.186,124.318q-.649,1.685-1.4,3.355a1.141,1.141,0,0,0-.109.738q.106.3.614,1.343l1.161,2.578q.08.373-.309.4-.368.024-.821.021a.688.688,0,0,1-.451-.425q-.456-1-.944-2.151a.436.436,0,0,0-.087-.272.115.115,0,0,0-.207.019q-.245.668-.512,1.324a8.036,8.036,0,0,1-.489,1.083,1.3,1.3,0,0,1-1.246.437.591.591,0,0,1-.2-.151l.031-.43,1.581-3.74a.658.658,0,0,0-.007-.529l-1.5-3.339q-.271-.6.389-.609l.319,0a.852.852,0,0,1,.847.538q.359.8.62,1.569a1.037,1.037,0,0,0,.262.411.092.092,0,0,0,.153-.036q.358-1.062.79-2.119c.191-.469.757-.413,1.173-.375Q51.1,123.978,51.186,124.318Z",
    transform: "translate(-25.621 -89.158)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38228",
    "data-name": "Path 38228",
    d: "M108.6,124.362a10.1,10.1,0,0,0,.12,3.11,2.984,2.984,0,0,0,1.234.082c.305-.035.5-.154.509-.477q.016-1.265.01-2.442,0-.734.781-.712a.629.629,0,0,1,.606.375q.026,3.94,0,7.866a.511.511,0,0,1-.25.495,1.415,1.415,0,0,1-.693.078.5.5,0,0,1-.434-.529q-.009-1.5-.033-3a.627.627,0,0,0-.54-.342c-.467-.023-1.3-.116-1.333.606q-.047,1.246-.033,2.65.007.7-.852.611a.662.662,0,0,1-.529-.7q.019-3.694.005-7.193c0-.724.375-1.128,1.107-.85A.7.7,0,0,1,108.6,124.362Z",
    transform: "translate(-76.017 -89.136)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38229",
    "data-name": "Path 38229",
    d: "M140.415,124.051q.842,4.1,1.611,8.009a.5.5,0,0,1-.085.444.51.51,0,0,1-.371.12q-.252.007-.6.038a2.215,2.215,0,0,1-.555-1.6,1.287,1.287,0,0,0-1.241-.382c-1.243.122-.474,1.5-1.333,1.869a1.616,1.616,0,0,1-.712.1q.042-.05-.238-.22l.1-1.215q.726-3.492,1.394-7.017a.448.448,0,0,1,.427-.4A2.408,2.408,0,0,1,140.415,124.051Zm-1.524,5.186q.042.1.087.109a2.634,2.634,0,0,0,.941.047.142.142,0,0,0,.1-.057.138.138,0,0,0,.024-.108l-.43-2.2a3.327,3.327,0,0,0-.12-.736q-.111-.356-.181.01-.243,1.291-.5,2.68A.394.394,0,0,0,138.891,129.237Z",
    transform: "translate(-100.587 -89.033)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38230",
    "data-name": "Path 38230",
    d: "M173.625,124.1q.014,3.931.019,7.759a1.333,1.333,0,0,1-.177.7.216.216,0,0,1-.128.1,2.179,2.179,0,0,1-.864.066,1.213,1.213,0,0,1-.483-.606q-.658-1.611-1.343-3.234l-.344-.774q-.219-.491-.212.045.019,1.79.005,3.959c-.005.606-.552.71-1.106.564l-.154-.132a.623.623,0,0,1-.132-.432q-.019-.647-.026-1.246l.007-6.585a.346.346,0,0,1,.3-.344c.649-.08,1.076-.121,1.369.564q.894,2.092,1.7,4.121a.175.175,0,0,0,.064.08.193.193,0,0,0,.061.028.067.067,0,0,0,.057-.012.063.063,0,0,0,.024-.052q-.047-2.116-.012-4.188a.551.551,0,0,1,.476-.542A.929.929,0,0,1,173.625,124.1Z",
    transform: "translate(-126.859 -89.136)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38231",
    "data-name": "Path 38231",
    d: "M236.368,124.326l-.031.66a.4.4,0,0,1-.4.378l-1.805-.016a.364.364,0,0,0-.368.351q-.028.708,0,1.3a.584.584,0,0,0,.123.387.359.359,0,0,0,.279.137q.828.007,1.654.035.17.005.264.252l-.042.583a.511.511,0,0,1-.516.474l-1.279-.014a.448.448,0,0,0-.451.411,12.8,12.8,0,0,0-.016,1.987q.012.163.111.161a.2.2,0,0,0,.106.042q.91.021,1.824.009a.593.593,0,0,1,.533.4q.087,1.01-.752.965a17.8,17.8,0,0,0-2.864.071.881.881,0,0,1-.422-.738q.01-3.846.026-7.582a.513.513,0,0,1,.576-.576q1.559-.005,3.031.009A.383.383,0,0,1,236.368,124.326Z",
    transform: "translate(-179.453 -89.218)",
    fill: "#144994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38232",
    "data-name": "Path 38232",
    d: "M191.691,125.05a.779.779,0,0,1,.3.642,14.507,14.507,0,0,0,.3,1.993l0,3.853a2.447,2.447,0,0,0-.314,1.43,1.361,1.361,0,0,1-.054.627.705.705,0,0,1-.609.356.761.761,0,0,1-.769-.273,2.178,2.178,0,0,0,.864-.066.216.216,0,0,0,.128-.1,1.333,1.333,0,0,0,.177-.7Q191.7,128.981,191.691,125.05Z",
    transform: "translate(-144.925 -90.084)",
    fill: "#fde584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38233",
    "data-name": "Path 38233",
    d: "M157.2,125.35a1.091,1.091,0,0,1,.293.415q.224,1.251.587,2.8.1.42.172.847.069.394.191.842a7.581,7.581,0,0,1,.213,1.106q.094.8.536.706.007.6.026,1.246a.623.623,0,0,0,.132.432q-.845.809-1.6.212.349-.031.6-.038a.51.51,0,0,0,.371-.12.5.5,0,0,0,.085-.444Q158.042,129.448,157.2,125.35Z",
    transform: "translate(-117.372 -90.332)",
    fill: "#fde584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38234",
    "data-name": "Path 38234",
    d: "M67.684,126.17a.352.352,0,0,1,.139.233.422.422,0,0,1-.021.245q-.661,1.656-1.35,3.126a.829.829,0,0,0-.04.628,4.843,4.843,0,0,0,.338.729.793.793,0,0,1,.035.476q-.509-1.043-.614-1.343a1.141,1.141,0,0,1,.109-.738Q67.035,127.855,67.684,126.17Z",
    transform: "translate(-42.12 -91.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38235",
    "data-name": "Path 38235",
    d: "M243.179,125.87a1.053,1.053,0,0,1,.153,1,.223.223,0,0,1-.1.128.8.8,0,0,1-.4.116q-.887.019-1.781.017a.268.268,0,0,0-.191.081.272.272,0,0,0-.078.194l.014,1.323a.206.206,0,0,1-.047.135l-.047.057a.584.584,0,0,1-.123-.387q-.03-.588,0-1.3a.365.365,0,0,1,.368-.351l1.805.016a.4.4,0,0,0,.4-.378Z",
    transform: "translate(-186.265 -90.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38236",
    "data-name": "Path 38236",
    d: "M129.732,126.18q.288.1.3.62.038,1.725-.01,3.324c-.019.64.135,1.244.08,1.9a2.445,2.445,0,0,0,.2,1.189l-.1,1.215a2.041,2.041,0,0,1-.632.4q-.566.158-.774-.2a1.416,1.416,0,0,0,.693-.078.511.511,0,0,0,.25-.495Q129.759,130.12,129.732,126.18Z",
    transform: "translate(-93.893 -91.018)",
    fill: "#fde584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38237",
    "data-name": "Path 38237",
    d: "M115.121,126.548q.139-.01.163.229a14.989,14.989,0,0,1-.043,2.881A10.1,10.1,0,0,1,115.121,126.548Z",
    transform: "translate(-82.541 -91.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38239",
    "data-name": "Path 38239",
    d: "M85.309,131.159q-1.255,0-1.276,1.116-.033,1.75.012,3.494.017.653.085,1.411a3.671,3.671,0,0,1-.351-1.779q.009-2.119.043-3.07a1.945,1.945,0,0,1,.246-1.012Q84.483,130.713,85.309,131.159Z",
    transform: "translate(-56.695 -94.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38240",
    "data-name": "Path 38240",
    d: "M210.358,131.129c-.384.071-.811.024-1.069.377a2.116,2.116,0,0,0-.255,1.106,25.24,25.24,0,0,0,.214,4.537,2.244,2.244,0,0,1-.387-1.3q-.049-2.086.005-3.595a1.8,1.8,0,0,1,.255-1Q209.544,130.679,210.358,131.129Z",
    transform: "translate(-160.046 -94.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38241",
    "data-name": "Path 38241",
    d: "M97.591,135.52l.2.115a.119.119,0,0,1,.064.144.186.186,0,0,0,.04.172.125.125,0,0,1,.019.144q-.476.981-1.479.312l.785.016a.346.346,0,0,0,.352-.337Z",
    transform: "translate(-67.158 -98.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38242",
    "data-name": "Path 38242",
    d: "M222.84,136.55a.879.879,0,0,1,.219.649.32.32,0,0,1-.224.281,1.06,1.06,0,0,1-1.1-.181,2.459,2.459,0,0,0,.951-.09.193.193,0,0,0,.118-.111A.862.862,0,0,0,222.84,136.55Z",
    transform: "translate(-170.709 -99.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38243",
    "data-name": "Path 38243",
    d: "M148.744,138.141a5.152,5.152,0,0,0-.55,2.066q-.007.113-.167.147a.394.394,0,0,1-.08-.259q.253-1.389.5-2.68.069-.366.181-.01A3.33,3.33,0,0,1,148.744,138.141Z",
    transform: "translate(-109.723 -100.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38244",
    "data-name": "Path 38244",
    d: "M149.137,142.48l.43,2.2a.138.138,0,0,1-.024.108.141.141,0,0,1-.1.057,2.635,2.635,0,0,1-.941-.047q-.045-.01-.087-.109.16-.035.167-.148A5.151,5.151,0,0,1,149.137,142.48Z",
    transform: "translate(-110.116 -104.489)",
    fill: "#fcd209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38246",
    "data-name": "Path 38246",
    d: "M31.319,146.29q.4.587.073.965a.687.687,0,0,1-.536.259q-.568.005-1.121,0a.483.483,0,0,0-.555.543l-.009,1.52a.22.22,0,0,1-.069.163.1.1,0,0,0-.042.094q-.066,0-.071-.1a15.6,15.6,0,0,1,.024-2.085.4.4,0,0,1,.37-.361,9.62,9.62,0,0,1,1.293,0Q31.411,147.345,31.319,146.29Z",
    transform: "translate(-11.394 -107.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38247",
    "data-name": "Path 38247",
    d: "M172.136,147.836a.32.32,0,0,0-.274.325,23.7,23.7,0,0,0,.01,2.84c.033.64-.273,1.022-.953.9a.572.572,0,0,1-.439-.267c.554.146,1.1.042,1.106-.564q.014-2.17-.005-3.959-.007-.536.212-.045Z",
    transform: "translate(-128.347 -108.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38248",
    "data-name": "Path 38248",
    d: "M112.968,152.784a2.726,2.726,0,0,1-.536-.1,1.58,1.58,0,0,0-.863.08.208.208,0,0,0-.134.122,1.577,1.577,0,0,0-.123.627q0,1.191.073,2.348.04.609-.647.687a.448.448,0,0,1-.528-.243q.859.087.852-.611-.014-1.4.033-2.65c.03-.722.866-.628,1.333-.606A.627.627,0,0,1,112.968,152.784Z",
    transform: "translate(-78.538 -112.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38249",
    "data-name": "Path 38249",
    d: "M49.881,158.353a10.2,10.2,0,0,0-.866,2.01,1.022,1.022,0,0,1-1.675.581,1.3,1.3,0,0,0,1.246-.437,8.04,8.04,0,0,0,.489-1.083q.267-.656.512-1.324a.115.115,0,0,1,.207-.019A.436.436,0,0,1,49.881,158.353Z",
    transform: "translate(-26.58 -117.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38250",
    "data-name": "Path 38250",
    d: "M85.96,162a.781.781,0,0,1,.141.826,2.478,2.478,0,0,1-.79,1.257,2.935,2.935,0,0,1-2.5.371.334.334,0,0,1-.163-.083.234.234,0,0,0-.137-.059.207.207,0,0,1-.207-.253,2.438,2.438,0,0,0,3.485-1.208A5.256,5.256,0,0,0,85.96,162Z",
    transform: "translate(-55.473 -120.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38251",
    "data-name": "Path 38251",
    d: "M141.546,163.887a5.349,5.349,0,0,0-1.248-.1c-.477.045-.533.637-.585,1.008a1.226,1.226,0,0,1-.236.58q-.46.611-1.217.1a1.617,1.617,0,0,0,.712-.1c.859-.368.09-1.748,1.333-1.869A1.287,1.287,0,0,1,141.546,163.887Z",
    transform: "translate(-101.719 -121.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38254",
    "data-name": "Path 38254",
    d: "M26.384,170.94a.84.84,0,0,0,.406.1l-.031.43a1.856,1.856,0,0,1-.746.382,16.648,16.648,0,0,1-3.333-.153,18.581,18.581,0,0,1,2.963-.082Q26.306,171.65,26.384,170.94Z",
    transform: "translate(-6.2 -128.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38255",
    "data-name": "Path 38255",
    d: "M71.15,172.34q.661.451-.222.689a.826.826,0,0,1-.908-.269q.453,0,.821-.021Q71.23,172.713,71.15,172.34Z",
    transform: "translate(-45.324 -129.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38256",
    "data-name": "Path 38256",
    d: "M97.174,182.2a.31.31,0,0,0-.351.109,13.676,13.676,0,0,1-2.046,2.609,13.853,13.853,0,0,1-10.117,3.912,13.185,13.185,0,0,1-3.414-.509,13.778,13.778,0,0,1-4.462-2.192,7.614,7.614,0,0,1-.8-.679.521.521,0,0,0-.6-.142.855.855,0,0,0-.325.26,1.774,1.774,0,0,1-.305.286,17.136,17.136,0,0,1-.545-3.211.215.215,0,0,1,.2-.259.64.64,0,0,1,.3.071q1.1.448,2.067.8a1.038,1.038,0,0,1,.488.316.775.775,0,0,1,.122.811.148.148,0,0,0-.021.094.17.17,0,0,0,.068.125,12.245,12.245,0,0,0,17.249-2.019c.125-.153.231-.276.455-.236a2.671,2.671,0,0,0,1.3-.255A.858.858,0,0,1,97.174,182.2Z",
    transform: "translate(-48.787 -137.189)",
    fill: "#e71d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38257",
    "data-name": "Path 38257",
    d: "M99.777,182.858a.236.236,0,0,1,.031.316A13.939,13.939,0,0,1,86.538,189.9a14.135,14.135,0,0,1-7.51-3.015,2.192,2.192,0,0,1-.326-.312,1.149,1.149,0,0,0-.38-.3.086.086,0,0,0-.109.031.9.9,0,0,1-.529.4q-.127.036-.323-.194a1.775,1.775,0,0,0,.305-.286.854.854,0,0,1,.325-.26.521.521,0,0,1,.6.142,7.61,7.61,0,0,0,.8.679,13.776,13.776,0,0,0,4.462,2.192,13.183,13.183,0,0,0,3.414.509,13.854,13.854,0,0,0,10.117-3.912,13.678,13.678,0,0,0,2.046-2.609A.31.31,0,0,1,99.777,182.858Z",
    transform: "translate(-51.389 -137.85)",
    fill: "#42488e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/Exchange.8ffa7089.svg";
export { ForwardRef as ReactComponent };